import './ReportCard.less';
import './ReportElement.less';
import React from 'react';
import ReportCategories from './ReportCategories';
import ReportSummary from './summary/ReportSummary';
import { CompetitorsResults, CompetitorsScoreData, ScoreData, SectionData } from './types';
import { filterSelectedCategorySections, getImportantFixes } from './utils';
import { AnalysisStructure } from '../types';
import ReportSidebar from './ReportSidebar';

type Props = {
    guid: string;
    url: string;
    structure: AnalysisStructure;
    scoreData: ScoreData;
    competitorsScoreData?: CompetitorsScoreData;
    totalSectionsCount: number;
    sectionResults: Record<string, SectionData>;
    competitorSectionResults?: Record<string, CompetitorsResults>;
    analysisProgress?: number;
    isFullReport: boolean;
    createdAt: string;
};

export default function AnalysisReport({
    guid,
    url,
    structure,
    scoreData,
    competitorsScoreData,
    totalSectionsCount,
    sectionResults,
    competitorSectionResults,
    analysisProgress,
    isFullReport,
    createdAt,
}: Props) {
    const importantFixes = getImportantFixes(sectionResults);
    const selectedCategories = filterSelectedCategorySections(structure, sectionResults);
    const selectedSections = sectionResults ? Object.keys(sectionResults) : [];

    return (
        <div
            data-cy="analysis-report"
            className="report-wrapper"
        >
            <div className="report-summary">
                <ReportSummary
                    id="header-seo-summary"
                    reportGuid={guid}
                    url={url}
                    scoreData={scoreData}
                    competitorsScoreData={competitorsScoreData}
                    importantFixesData={importantFixes}
                    totalSectionsCount={totalSectionsCount}
                    selectedSections={selectedSections}
                    createdAt={createdAt}
                    analysisProgress={analysisProgress}
                    isFullReport={isFullReport}
                    showRefreshReport
                    showDownloadPdf
                    showWhiteLabel
                />

                <ReportCategories
                    url={url}
                    categories={selectedCategories}
                    sections={sectionResults}
                    competitorsSections={competitorSectionResults}
                />

                {Object.keys(sectionResults).length >= 5 && (
                    <ReportSummary
                        id="footer-seo-summary"
                        reportGuid={guid}
                        url={url}
                        scoreData={scoreData}
                        competitorsScoreData={competitorsScoreData}
                        importantFixesData={importantFixes}
                        totalSectionsCount={totalSectionsCount}
                        selectedSections={selectedSections}
                        createdAt={createdAt}
                        analysisProgress={analysisProgress}
                        isFullReport={isFullReport}
                        showRefreshReport
                        showDownloadPdf
                        showWhiteLabel
                    />
                )}
            </div>

            <ReportSidebar
                scoreData={scoreData}
                categories={selectedCategories}
                sections={sectionResults}
            />
        </div>
    );
}
